<div class="contenido" style="background: #F6F6F6;" >
    <div class="container" style="background: #F6F6F6;">
        <div class="row pt-3 d-flex justify-content-between">
            <div class="col-12">
                <div class="row d-flex justify-content-around">
                    <div class="card col-12 col-lg-3 px-0 bordeblue">
                        <div class="card-header py-1">
                            <div class="col-12 text-center px-0">
                                <label class="h5 mb-0 d-flex align-items-center justify-content-center">
                                    <i class="fa-solid fa-filter mr-2"></i> Artículo
                                </label>
                            </div>
                        </div>
                        <div class="card-body row py-3">
                            <div class="col-12">
                                <input class="form-control mr-sm-2"  [(ngModel)]="strBusqueda" type="search" placeholder="Buscar" aria-label="Search">
                            </div>
                        </div>
                    </div>

                    <div class="card col-12 mt-3 mt-lg-0 col-lg-3 px-0 bordeblue">
                        <div class="card-header py-1">
                            <div class="col-12 text-center  px-0">
                                <label class="h5 mb-0 d-flex align-items-center justify-content-center">
                                    <i class="fa-solid fa-filter mr-2"></i> Proveedor
                                </label>
                            </div>
                        </div>
                        <div class="card-body row py-3">
                            <div class="col-12">
                                <div class="input-group">
                                   
                                        <label class="input-group-text" for="inputGroupSelect01">
                                            Proveedor
                                        </label>
                                   
                                    <select class="form-select" id="inputGroupSelect03" [(ngModel)]="strProveedor">
                                        <option value="-1" selected >--Todos--</option>
                                        <ng-container *ngFor="let A of arrayProveedor">
                                            <option   value="{{A.strProveedor}}"  >      {{A.strNombre}} -- {{A.strProveedor}} </option>
                                        </ng-container>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card col-12 mt-3 mt-lg-0 col-lg-3 px-0 bordeblue">
                        <div class="card-header py-1">
                            <div class="col-12 text-center  px-0">
                                <label class="h5 mb-0 d-flex align-items-center justify-content-center">
                                    <i class="fa-solid fa-filter mr-2"></i>Almacén
                                </label>
                            </div>
                        </div>
                        <div class="card-body row py-3">
                            <div class="col-12">
                                <div class="input-group">
                                   
                                        <label class="input-group-text" for="inputGroupSelect01">
                                            Almacén
                                        </label>
                                   
                                    <select class="form-select" id="inputGroupSelect01" [(ngModel)]="almacenDestino">
                                        <option value="-1" selected >--Todos--</option>
                                        <ng-container *ngFor="let A of arrayAlmacenes">
                                          <!--   <ng-container *ngFor="let A of arrayEncabezados">  -->
                                            <option   value="{{A.strAlmacen}}" *ngIf="A.arrayresult?.length>0">{{A.strNombreAlm}}</option>
                                        </ng-container>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
               
                  
                 </div>
            </div>
        </div>
         <!-----segunda fila-->
        <div class="row pt-3 d-flex justify-content-between">
            <div class="col-12">
                <div class="row d-flex justify-content-around">
                    <div class="card col-12 mt-3 mt-lg-0 col-lg-3 px-0 bordeblue">
                    <div class="card-header py-1 px-1 ">
                        <div class="col-12 text-center px-0">
                            <label class="h5 mb-0">
                                <i class="fa fa-solid fa-circle-down mr-2"></i>Descargar
                            </label>
                        </div>
                    </div>
                    <div class="card-body row  py-2" style="max-height: 90px;">
                        <div class="text-center col-12 d-flex justify-content-center"   *ngIf="spiner" >
                            <mat-spinner [diameter]="50"  #spinner></mat-spinner> <!-- <img  src="assets/img/cargando.gif"alt="" class="w-25" > -->
                        </div>
                        <div *ngIf="!spiner" class="col-12 text-center d-flex justify-content-center">
                            <button (click)="exportToExcel()" class="btn text-success p-0"><i class="fa-solid fa-file-excel h2 mb-0"></i></button>
                        </div>
                    </div>
                    </div>
                    <div class="card col-12 mt-3 mt-lg-0 col-lg-3 px-0 bordeblue">
                    <div class="card-header py-1 px-1 ">
                        <div class="col-12 text-center px-0"><label class="h5 mb-0"><i class="fa fa-box-open mr-2"></i>Total Cantidad</label></div>
                    </div>
                    <div class="card-body row py-2">
                        <div class="col-12 text-center d-flex align-items-center justify-content-center">
                            <label style="background:#3f9124" class=" mb-0 text-white rounded p-1 font-weight-bold">
                             <b class="h5">{{fnsumarCantidadtotales() |number:'1.2-2'}}</b> 
                            </label>
                        </div>
                    </div>
                    </div>

                    <div class="card col-12 mt-3 mt-lg-0 col-lg-3 px-0 bordeblue">
                        <div class="card-header py-1 px-1 ">
                            <div class="col-12 text-center px-0">
                                <label class="h5 mb-0 d-flex justify-content-center"><mat-icon>payment</mat-icon>Total Importe</label>
                                </div>
                        </div>
                        <div class="card-body row py-2">
                            <div class="col-12 text-center d-flex align-items-center justify-content-center">
                                <label style="background:#3f9124" class=" mb-0 text-white rounded p-1 font-weight-bold">
                                 <b class="h5 "> {{fnsumarpesostotales()| currency }} MXN</b>
                                </label>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
        </div>  


        <!---fin--segunda fila-->     
         <div class="text-center mt-4 d-flex justify-content-center col-12" *ngIf="spiner">
            <mat-spinner></mat-spinner>
             <!-- <img src="assets/img/cargando.gif" style="height: 75vh;"alt=""> -->
        </div>
         <div *ngIf="!spiner">
            <div class="d-flex justify-content-center align-items-center flex-column" *ngIf="imgError">
                <label for="" class="text-center alert alert-danger">No existen articulos por comprar</label>
                <img src="assets/img/errorcompra.jpeg" style="height: 75vh;"alt="">
            </div>
            <div *ngIf="!imgError">
                <div class="table-container row" *ngFor="let almD of arrayEncabezados | filtrarAlmOriDes:almacenDestino:'strAlmacen':strProveedor;let ind = index;" #pdfTable>
                    <div class="mt-5 col-12" *ngIf="almD.arrayresult && (almD.arrayresult | filtrarAlmArticulos: strBusqueda).length>0">
                        <div class="table-responsive mb-0">
                            <table  class="widtable w-100 table table-hover table-bordered mb-0" id="tabla">
                                <thead class="topsticky">
                                    <tr class="cabeceraTransitos">
                                        <th class="text-center" colspan="12">
                                            <div class="col-12">
                                            <div class="row d-flex justify-content-center">
                                            <div class="col-3 ">
                                                <label for="" class="bg-light mb-0 shadow p-1 rounded text-dark  font-weight-light">Proveedor:
                                                    {{almD.strProveedor}}
                                                </label>
                                            </div>
                                            <div class="col-4">
                                           <label for="" style="background:#F7990F" class=" text-white  mb-0 shadow p-1 rounded  font-weight-light d-flex align-items-center"> Almacén:
                                                <!-- bg-light  (change)="onAlmacenChange(ind,almD.strAlmacen)"   <label style="background:#F7990F" class=" mb-0 text-white form-control rounded py-4 font-weight-light d-flex align-items-center"> -->
                                                      <span class="pe-2">({{almD.strAlmacen}}) </span>  
                                                        <select class="form-select"  [(ngModel)]="almD.strAlmacen"  (change)="onAlmacenChange(ind,almD.strAlmacen)">              
                                                                <option *ngFor="let A of arrayAlmacenesSelectEncabezado"  value="{{A.strAlmacen}}" 
                                                                [ngClass]="{'d-none':almD.strProveedor != A.strProveedor}">
                                                                 {{A.strNombreAlm}}
                                                                </option>
                                                        </select>
                                                   <!--  </label> -->
                                                </label>  <!--  {{almD.strNombreAlm}}    [ngClass]="{'d-none': almD.strNombreAlm == A.strNombreAlm}" -->
                                               </div>
                                               <div class="col-5 text-center d-flex">
                                                   <div class="col-7">
                                                       <div class="input-group"> 
                                                           <select class="form-select" id="inputGroupSelect01" [(ngModel)]="almD.strAlm_Origen">    
                                                               <ng-container *ngFor="let A of arrayEncabezados">
                                                                   <option  [ngClass]="{'d-none': almD.strNombreAlm == A.strNombreAlm}"  
                                                                   value="{{A.strAlmacen}}" 
                                                                   *ngIf="A.arrayresult.length>0  && (A.arrayresult | filtrarAlmArticulos:almD.strProveedor:'1').length>0">
                                                                    {{A.strNombreAlm}}</option>
                                                               </ng-container>
                                                            </select> 
                                                            <button class="btn btn-primary" [disabled]="almD.strAlmacen == almD.strAlm_Origen || almD.strAlm_Origen == undefined  || almD.strAlm_Origen == -1" (click)="fnUnificar(almD.strAlm_Origen,almD.strNombreAlm, almD.strProveedor)">Unificar</button>
                                                        </div>
                                                        
                                                   </div>
                                                   <div class="col-3">
                                                    <div class="col-12 d-flex justify-content-end">
                                                                <!-- Button trigger modal -->
                                                                <button type="button" class="btn btn-success ms-3 p-2 d-flex justify-content-center align-items-center" data-toggle="modal" data-target="#exampleModal" (click)="fnOpenModal_Add(almD,almD.strProveedor)">
                                                                    <mat-icon>add_shopping_cart</mat-icon>
                                                                </button>
                                                        </div>
                                                   </div>
                                               </div>
                                        </div>
                                        </div>
                                    </th>
                                </tr>                       
                                <tr class="cabeceraTitulo"> 
                                    <th class="text-center"></th>
                                    <!--<th class="text-center">Almacen</th> -->
                                    <th class="text-center">Artículo</th>
                                    <th class="text-center">Descripción</th>
                                    <th class="text-center">Opcion</th>
                                    <th class="text-center">Cantidad</th>
                                    <th class="text-center">Unidad</th>
                                    <th class="text-center">Factor</th>
                                    <th class="text-center">Precio</th>
                                    <th class="text-center">Descuento</th>
                                    <th class="text-center">Total</th>
                                    
                                  
                                </tr>
                            </thead>
                            <tbody class="">
                                <tr *ngFor="let registro of almD.arrayresult  | filtrarAlmArticulos: strBusqueda ; let i = index">
                                    <td class="text-center"><a (click)="fnEliminar(almD.strAlmacen,i)"><i class="fa-solid fa-circle-xmark colorR"></i></a></td>
                                    
                                    <!--<td class="text-left text-nowrap fzTbl12">({{registro.strAlm_destino}}){{registro.strAlm_destinoNombre}}</td>-->
                                   
                                    <td class="text-left"><span [title]="registro.strCaso">{{registro.strArticulo}} <br><b>Clave Fabricante:</b> {{registro.strClaveFabricante}}</span> </td>
                                    <td class="text-left text-nowrap fzTbl12" [innerHTML]="formatDescripcion(registro.strDescripcion)"></td>
                                    <td class="text-left">{{registro.strNombreOpcion}} <span *ngIf="registro.strOpcion!=''">({{registro.strOpcion}})</span> </td>
                                    
                                    <td class="text-right"><input  class="text-end form-control dynamic-width-input" type="number" [(ngModel)]="registro.dblCantidad " (change)="cambiarCantidad(registro , registro.dblCantidad)" min="1"  pattern="\d{1,4}(,\d{1,3})?(\.\d{1,2})?"></td>  
                                    <td class="text-center">{{registro.strUnidad}} </td>
                                    <td class="text-center">{{registro.strFactor}} </td>
                                    <td class="text-right"> 
                                        <span *ngIf="registro.strEstado=='PrecioConvenio'" style="color: darkblue;" title="{{registro.strEstado}} "> {{registro.dblPrecio | currency }}
                                        <br> <span style="font-size: 8px;">{{registro.strEstatusxAlm}}</span>
                                        </span>
                                        <span *ngIf="registro.strEstado!='PrecioConvenio'" title="{{registro.strEstado}} + {{registro.strEstatusxAlm}}"> {{registro.dblPrecio | currency }}</span>
                                       
                                    </td>
                                    <td class="text-right">{{registro.dblDescuento}}  
                                    </td>
                                    <td class="text-right">{{registro.dblPrecio *registro.dblCantidad| currency}}  
                                    </td>
                                    
                                    <!--<td class="text-right">{{registro.dblVolumen | number:'1.2-2'}}  
                                    </td>
                                    <td class="text-right">{{(registro.dblVolumen*registro.dblCantidad) | number:'1.2-2'}}  
                                    </td>-->
                                    <!--<td class="text-right">{{registro.dblPeso | number:'1.2-2'}}  
                                    </td>
                                    <td class="text-right">{{(registro.dblPeso*registro.dblCantidad) | number:'1.2-2'}}  
                                    </td>-->
                                </tr>
                            </tbody>
                            <tfoot class="topstickyfoot "   >
                                <tr class="bgfoot">
                                    <td  colspan="4" >
                                        <div class="row d-flex">
                                           <div class="col-6 d-flex flex-column  align-items-center  justify-content-center">
                                            <span class="font-weight-bold text-white">Fecha Requerida:</span>
                                                <input type="date" [(ngModel)]="almD.fechaEntrega" class="form-control col-8"  >
                                           </div>
                                           <div class="col-6 d-flex justify-content-center  align-items-center flex-column">
                                            <button  type="button" class="btn btn-primary shadow" (click)="fnSetOrdenCompra(almD.strAlmacen,almD.strAlm_destino,almD.arrayresult, almD,almD.fechaEntrega,almD.strProveedor)">Generar Orden de Compra</button>
                                          <!--   <button  type="button" class="btn btn-primary shadow mt-5" (click)="fnPdf('ORDEN124Prueba',almD.arrayresult,almD.fechaEntrega,almD)">Generar pdf</button>
                                      -->   </div>
                                       </div>
                                    </td>
                                    <td class="">
                                        <div class="col-12 d-flex justify-content-end text-right">
                                            <label style="background: #1C3150;" class="mb-0 text-white rounded p-1 font-weight-light">
                                                {{sumarCantidad(almD.strNombreAlm, almD.strProveedor)| number:'1.2-2' }}
                                            </label>
                                        </div>
                                    </td>
                                    <td class="text-right ">
                                    </td>   
                                    <td class="text-right ">
                                    </td>   


                                    <td class="text-right ">
                                      <!--  <label style="background: #1C3150;" class="mb-0 text-white rounded p-1 font-weight-light text-nowrap">
                                      {{sumarPrecio(almD.strNombreAlm, almD.strProveedor)|currency}}   
                                        </label>-->
                                    </td>
                                    
                                    <td class="text-right ">
                                        <!--<label style="background: #1C3150;" class="mb-0 text-white rounded p-1 font-weight-light text-nowrap">
                                            {{sumarDescuento(almD.strNombreAlm)}}     
                                        </label>-->
                                  </td>
                                  <td class="text-right ">
                                    <label style="background: #1C3150;" class="mb-0 text-white rounded p-1 font-weight-light text-nowrap">
                                        {{sumarPrecioT(almD.strNombreAlm, almD.strProveedor)|currency}}  <!--     {{ sumarVolumenT(almD.strNombreAlm)| number:'1.2-2' }} m3 -->
                                </label>
                                </td>
                                  <!--<td class="text-right ">
                                    <label style="background: #1C3150;" class="mb-0 text-white rounded p-1 font-weight-light ">
                                        {{ sumarVolumenT(almD.strNombreAlm)| number:'1.2-2' }} m3
                                    </label>
                                  </td>
                                  <td class="text-right ">
                                    <label style="background: #1C3150;" class="mb-0 text-white rounded p-1 font-weight-light ">
                                      {{ sumarPesoT(almD.strNombreAlm)| number:'1.2-2' }} kg
                                    </label>
                                  </td>-->
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                     
                </div>
             </div>
            </div>
     </div>
     </div>

     <!-- Modal --> 
     <!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title" id="exampleModalLabel">Agregar Artículo</h2>
          <button type="button" (click)="fnLimpiarModal();" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Artículo" aria-label="Artículo" aria-describedby="button-addon2" [(ngModel)]="strBuscar">
                            <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="fnGetBusquedaArt(strBuscar)">Buscar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!--TABLE-->
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive div100">
                            <table class="col-12 table table-striped tablewidt100">
                            <thead>
                              <tr>
                                <th> Artículo</th>
                                <th> Descripción</th>
                                <th> Cantidad</th>
                                <th>Opcion</th>
                                <th> Precio</th>
                                <th> Agregar</th> 
                              </tr>
                            </thead>
                            <tbody>
                              <tr class="col-12" *ngFor="let A of arrayBusquedaArt">
                                <th scope="row">{{A.strArticulo}} <br> </th>
                                <td class="text-left text-nowrap fzTbl12" [innerHTML]="formatDescripcion(A.strDescripcion)"></td>
                                <td  class="col-4 col-sm-3">
                                    <div class="input-group mb-3">
                                    <input type="number" class="form-control"   aria-label="Recipient's username" aria-describedby="basic-addon2" [(ngModel)]="A.dblCantidad">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon2">{{A.strUnidad}}</span> 
                                    </div>
                                    </div>
                                </td>
                                <td class="text-center"> 
                                    <select *ngIf="A.arrayOpciones && A.arrayOpciones.length > 0" class="form-control form-control-sm" [(ngModel)]="A.objOpcion" >
                                        <option [ngValue]="x"  *ngFor="let x of A.arrayOpciones" >{{x.strNombreOpcion}}</option>
                                      </select>
                                </td>
                                <td>
                                    {{A.dblPrecio |currency}}
                                </td>
                                <td> <button class="btn btn-success p-2 d-flex justify-content-center align-items-center" (click)="fnAddArt(A)" ><mat-icon>add_shopping_cart</mat-icon></button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                    </div>
                </div>
                <!--FIN---TABLE-->
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="fnLimpiarModal();" data-dismiss="modal">Cerrar</button>
          <!--<button type="button" class="btn btn-primary">Añadir</button>-->
        </div>
      </div>
    </div>
  </div>
     <!--MODAL-->
    <!--  <ng-template #listaArticulos let modal>
       <div class="modal-header">
           <h4 class="modal-title">
             <i class="fa-solid fa-box"></i>
               &nbsp;&nbsp; 
               <span>Listado de Artículos</span>
           </h4>
           <button class="close" aria-label="close" type="button" (click)="cerrarModal()">
               <span aria-hidden="true">&times;</span>
           </button>
 
       </div>
       <div class="modal-body">
         <mat-form-field appearance="outline" >
             <mat-label>Articulos</mat-label>
             <mat-select [(ngModel)]="strArticulo" #singleSelectS>
                 <mat-label>Selecciona una opción</mat-label>
                 <mat-option value="{{articulo.strArticulo}}" *ngFor="let articulo of ArrayArticulos">{{articulo.strArticulo}}</mat-option>
                 
             </mat-select>
         </mat-form-field>    
       </div>
       <div class="modal-footer">
         <button type="button" class="btn btn-success">AgregarArticulo</button>
         <button type="button" class="btn btn-danger" (click)="cerrarModal()">Cerrar</button>
 
       </div>
   </ng-template> -->
   <!--MODAL-->
 
 </div>
 